<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">宠物管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <label style="margin-left: 16px;">宠物性别</label>
              <el-select v-model="sex" placeholder="Select" class="select-item">
                <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>绝育状态</label>
              <el-select v-model="neuteringState" placeholder="Select" class="select-item">
                <el-option v-for="item in neuteringStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <label style="margin-left: 16px;">疫苗状态</label>
              <el-select v-model="exemptionState" placeholder="Select" class="select-item">
                <el-option v-for="item in exemptionStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>外驱状态</label>
              <el-select v-model="outDriveState" placeholder="Select" class="select-item">
                <el-option v-for="item in outDriveStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <label style="margin-left: 16px;">内驱状态</label>
              <el-select v-model="inDriveState" placeholder="Select" class="select-item">
                <el-option v-for="item in inDriveStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <el-select v-model="timeType" placeholder="Select" style="width: 14em">
                <el-option v-for="item in timeTypeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <DatePickerRange_1 title="" labelWidth="0em" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>

            <div class="content-input-item">
              <!--              <label>客户搜索</label>-->
              <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>


          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <el-space>
<!--            <el-button type="primary" @click="editUserDialog(-1)" size="default">添加客户</el-button>-->
<!--            <el-button type="danger" @click="getCustom()" size="default">门店散客</el-button>-->
<!--            <el-divider direction="vertical"></el-divider>-->
            <el-badge is-dot :hidden="exemptionNum == 0">
              <el-button @click="getBtnPage(1, true)" size="default">疫苗时间已到<span v-if="exemptionNum > 0">（{{exemptionNum}}）</span></el-button>
            </el-badge>
            <el-badge is-dot :hidden="outDriveNum == 0">
              <el-button @click="getBtnPage(2, true)" size="default">外驱时间已到<span v-if="outDriveNum > 0">（{{outDriveNum}}）</span></el-button>
            </el-badge>
            <el-badge is-dot :hidden="inDriveNum == 0">
              <el-button @click="getBtnPage(3, true)" size="default">内驱时间已到<span v-if="inDriveNum > 0">（{{inDriveNum}}）</span></el-button>
            </el-badge>
          </el-space>
          <div style="display: flex;align-items: center;">
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="name" label="宠物昵称" v-if="checkColList.indexOf('宠物昵称') > -1"/>
            <el-table-column property="" label="服务记录" v-if="checkColList.indexOf('服务记录') > -1" class-name="cursor" width="240">
              <template #default="scope">
                <div v-for="(item,index) in scope.row.projectOnePetList" :key="index" style="margin: 8px 0; font-size: 14px; display: flex; flex-wrap: wrap;">
                  <span style="margin-right: 8px;">{{item.showTime}}</span>
                  <el-tag size="small" style="margin-right: 8px;">{{item.operateAdminName}}</el-tag>
                  <span>服务项目：{{item.name}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="体重记录" v-if="checkColList.indexOf('体重记录') > -1" class-name="cursor" width="240">
              <template #default="scope">
                <div v-for="(item,index) in scope.row.petWeightAbduceList" :key="index" style="margin: 8px 0; font-size: 14px; display: flex; flex-wrap: wrap;">
                  <span style="margin-right: 8px;">{{item.updateTime}}</span>
                  <el-tag size="small" style="margin-right: 8px;">{{item.adminName}}</el-tag>
                  <span>体重：{{item.weight}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="宠物主人" v-if="checkColList.indexOf('宠物主人') > -1" width="180">
              <template #default="scope">
                <p @click="userInfoDialog(scope.row.userId)">主人：<span style="color: #3a8ee6; cursor: pointer">{{scope.row.userName}}</span></p>
<!--                <p>主人：{{scope.row.userName}}</p>-->
                <p>性别：{{scope.row.userSex == 1?'男':scope.row.userSex == 2?'女':'未知'}}</p>
                <p>手机：{{scope.row.phone}}</p>
                <p>门店：{{scope.row.userShopName}}</p>
                <p>主人ID：{{scope.row.uid}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="性别" v-if="checkColList.indexOf('性别') > -1">
              <template #default="scope">
                <span>{{scope.row.sex == 1?'弟弟':scope.row.sex == 2?'妹妹':'未知'}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="品种" v-if="checkColList.indexOf('品种') > -1" >
              <template #default="scope">
                <span>{{scope.row.petBreedName}}/{{scope.row.petBreedColorName}}{{scope.row.woolState == 1?'短毛':scope.row.woolState == 2?'长毛':''}}</span>
              </template>
            </el-table-column>
            <el-table-column property="birthday" label="出生日期" v-if="checkColList.indexOf('出生日期') > -1" width="104"/>
            <el-table-column property="" label="绝育情况" v-if="checkColList.indexOf('绝育情况') > -1" width="104">
              <template #default="scope">
                <span>{{scope.row.neuteringState == 1?'已绝育':scope.row.neuteringState == 2?'未绝育':'未知'}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="下次疫苗驱虫时间" v-if="checkColList.indexOf('下次疫苗驱虫时间') > -1" width="220">
              <template #default="scope">
                <p v-if="scope.row.nextExemptionDate">下次疫苗时间：{{scope.row.nextExemptionDate}}</p>
                <p v-if="scope.row.nextInDriveDate">下次内驱时间：{{scope.row.nextInDriveDate}}</p>
                <p v-if="scope.row.nextOutDriveDate">下次外驱时间：{{scope.row.nextOutDriveDate}}</p>
                <p v-if="scope.row.exemptionDesc" style="color: red; font-size: 12px; line-height: 1.3">*{{scope.row.exemptionDesc}}</p>
              </template>
            </el-table-column>
            <el-table-column property="description" label="特征" v-if="checkColList.indexOf('特征') > -1"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button type="primary" size="small" @click="updatePet(scope.$index, scope.row)">编辑</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData,imgPostFormData } from "@/api/api";
import {
  getPetCustomerPageList,
  getExemptionAllNum, getPet,
} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserRemark from "@/components/Remark/UserRemark";
import VisitLog from "@/components/VisitLog/VisitLog";
import UserLogList from "@/components/UserLogList/UserLogList";
import UserInfo from "@/components/User/userInfo"
import ConsumeList from "@/views/user/components/ConsumeList";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import unLock from "@/layout/components/unLock";
import DatePickerRange_1 from "@/components/DatePickerRange_7_1";
import DatePickerRange from "@/components/DatePickerRange_7";
import PetProjectOneDialog from "@/views/user/components/PetProjectOneDialog";
import RecordList from "@/views/user/components/RecordList";
import AddOrUpdatePet from "@/views/user/components/AddOrUpdatePet";
import userInfoDialog from "@/components/User/userInfoDialog";
import PetWeightDialog from "@/views/user/components/PetWeightDialog";

export default {
  name: "UserList",
  components: { BtnGroup, SearchComponents, ConsumeList, unLock, RecordList, DatePickerRange_1, DatePickerRange},
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      sexArray: [
        {label: '不限', value: -1},
        {label: '弟弟', value: 1},
        {label: '妹妹', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,

      neuteringStateArray: [
        {label: '不限', value: -1},
        {label: '已绝育', value: 1},
        {label: '未绝育', value: 2},
        {label: '未知', value: 0},
      ],
      neuteringState: -1,

      exemptionStateArray: [
        {label: '不限', value: -1},
        {label: '时间未到', value: 1},
        {label: '时间临近', value: 3},
        {label: '时间已到', value: 2},
      ],
      exemptionState: -1,

      outDriveStateArray: [
        {label: '不限', value: -1},
        {label: '时间未到', value: 1},
        {label: '时间临近', value: 3},
        {label: '时间已到', value: 2}
      ],
      outDriveState: -1,

      inDriveStateArray: [
        {label: '不限', value: -1},
        {label: '时间未到', value: 1},
        {label: '时间临近', value: 3},
        {label: '时间已到', value: 2}
      ],
      inDriveState: -1,

      weChatLoginStateArray: [
        {label: '不限', value: -1},
        {label: '未登录', value: 0},
        {label: '已登录', value: 1},
      ],
      weChatLoginState: -1,

      //刷新组
      colList: ['宠物昵称', '服务记录', '体重记录', '宠物主人', '性别', '品种', '出生日期', '绝育情况', '下次疫苗驱虫时间', '特征', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '宠物昵称', value : 3},
        {label : '主人ID', value : 4},
      ],
      searchType: 1,
      searchValue: '',
      limitState: true,

      upUserLoading: false,
      upPetLoading: false,

      exemptionNum: 0,
      outDriveNum: 0,
      inDriveNum: 0,
      btnType: 0,

      consumeNumMin: '',
      consumeNumMax: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      timeTypeArray: [
        {label: '出生日期', value: 1},
        {label: '下次疫苗时间', value: 2},
        {label: '下次内驱时间', value: 3},
        {label: '下次外驱时间', value: 4},
      ],
      timeType: 1,

      sort: 1,
    }
  },
  methods: {
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.limitState = true;
      this.sex = -1;
      this.sort = 1;
      this.timeType = 1;
      this.exemptionState = -1;
      this.outDriveState = -1;
      this.inDriveState = -1;
      this.shopId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    userInfoDialog(id) {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: id,
          width: '640px',
        },
        confirm: () => {
        }
      })
    },

    // //排序
    // sortChange(column) {
    //   if(column.prop == 'preBookTime') {
    //     if(column.order == 'descending') {
    //       this.sort = 3;
    //     } else if(column.order == 'ascending') {
    //       this.sort = 4;
    //     }
    //   } else if(column.prop == 'preBookNum') {
    //     if(column.order == 'descending') {
    //       this.sort = 5;
    //     } else if(column.order == 'ascending') {
    //       this.sort = 6;
    //     }
    //   }
    //   this.getPage();
    // },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      if(this.btnType == 0) {
        this.getPage();
      }else {
        this.getBtnPage(this.btnType)
      }
    },

    getPage(reset) {
      this.btnType = 0
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          this.sort = 1
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['sex'] = this.sex;
      param['inDriveState'] = this.inDriveState;
      param['outDriveState'] = this.outDriveState;
      param['exemptionState'] = this.exemptionState;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      // param['sort'] = this.sort;
      param['neuteringState'] = this.neuteringState;
      param['timeType'] = this.timeType;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPetCustomerPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getAllNum()
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getBtnPage(type, reset) {
      this.btnType = type
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;

        let param = {};
        param['pageNum'] = this.currentPage;
        param['shopId'] = this.shopId;
        param['neuteringState'] = -1;
        param['timeType'] = 1;
        param['sex'] = -1;
        switch (type) {
          case 1:
            param['inDriveState'] = -1;
            param['outDriveState'] = -1;
            param['exemptionState'] = 2;
            break;
          case 2:
            param['inDriveState'] = -1;
            param['outDriveState'] = 2;
            param['exemptionState'] = -1;
            break;
          case 3:
            param['inDriveState'] = 2;
            param['outDriveState'] = -1;
            param['exemptionState'] = -1;
            break;
        }
        param['searchType'] = 1;
        param['searchValue'] = '';

        this.sendPageReq(param);
      }
    },


    compare(a, b) {
      const bandA = a.shopId;
      const bandB = b.shopId;

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },



    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if(column.label == '服务记录') {
        Dialog.open({
          title: '【' +row.name + '】的服务记录',
          component: PetProjectOneDialog,
          data: {
            id: row.id,
            width: '1100px'
          },
          close: () => {
            // row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
            // this.getPage()
          }
        })
      }

      if(column.label == '体重记录') {
        Dialog.open({
          title: '【' +row.name + '】的体重记录',
          component: PetWeightDialog,
          data: {
            id: row.id,
            width: '1100px'
          },
          close: () => {
          }
        })
      }


    },


    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.userImgList,
          id: row.id,
          width: 908,
          from: 1
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    getAllNum() {
      getFormData(getExemptionAllNum, {shopId: this.shopId}).then(data => {
        this.exemptionNum = data.data.exemptionNum
        this.outDriveNum = data.data.outDriveNum
        this.inDriveNum = data.data.inDriveNum
      })
    },

    updatePet(idx, row) {
      getFormData(getPet, {id: row.id}).then(data => {
        let _title = '';
        let petForm = {}
        _title = '编辑宠物'
        petForm = data.data

        Drawer.open({
          title: _title,
          component: AddOrUpdatePet,
          data: {
            petForm: petForm,
            ids: idx,
            userId: row.userId,
            width: 600
          },
          confirm: (result) => {
            this.getPage()
          }
        })
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/

.item-img {
  width: 80px;
  height: 80px;
}


</style>
